import React from 'react';
import { createPortal } from 'react-dom';

export default function Modal({
  id,
  isOpen,
  title = '',
  message = '',
  onConfirm,
  onCancel,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  extraButton, // optional: { text, onClick, className }
  children,
  confirmDisabled = false,
  cancelDisabled = false,
}) {
  const overlayMouseDownRef = React.useRef(false);

  if (!isOpen) return null;

  const handleOverlayMouseDown = (event) => {
    overlayMouseDownRef.current = event.target === event.currentTarget;
  };

  const handleOverlayClick = (event) => {
    const isOverlayClick = event.target === event.currentTarget;
    const startedOnOverlay = overlayMouseDownRef.current;
    overlayMouseDownRef.current = false;

    if (!isOverlayClick || !startedOnOverlay) return;
    onCancel?.();
  };

  const modalNode = (
    <div
      className="modalOverlay"
      onMouseDown={handleOverlayMouseDown}
      onClick={handleOverlayClick}
    >
      <div className="modal" id={id} onClick={e => e.stopPropagation()}>
        {title && (
          <div className="modalHeader">
            <h2 className="modalTitle">{title}</h2>
          </div>
        )}

        <div className="modalBody">
          {message && <p className="modalMessage">{message}</p>}
          {children}
        </div>

        <div className="modalFooter modalButtons">
          <button onClick={onCancel} disabled={cancelDisabled}>{cancelText}</button>
          {extraButton && (
            <button className={extraButton.className || ''} onClick={extraButton.onClick}>
              {extraButton.text}
            </button>
          )}
          <button className="primary" onClick={onConfirm} disabled={confirmDisabled}>
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );

  if (typeof document === 'undefined' || !document.body) {
    return modalNode;
  }

  return createPortal(modalNode, document.body);
}
